import { render, staticRenderFns } from "./HelpCard.vue?vue&type=template&id=05fc7ff0&scoped=true&lang=pug&"
import script from "./HelpCard.vue?vue&type=script&lang=ts&"
export * from "./HelpCard.vue?vue&type=script&lang=ts&"
import style0 from "./HelpCard.vue?vue&type=style&index=0&id=05fc7ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc7ff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
